import { Box, Stack } from '@mui/material';
import { Button, Typography } from '@sweep-io/sweep-design';
import { InviteUsersInputWithList } from '../../common/invite-users/InviteUsersInputWithList';
import { InviteUsersDialog } from '../../common/invite-users/InviteUsersDialog';
import { useRoleManagerContext } from '../role-manager/RoleManagerContext';
import { useSweepRoleGroups } from '../../common/useSweepRoleGroups';
import { usePermissions } from '../../../permissions/usePermissions';
import { useInviteUsers } from '../../common/invite-users/useInviteUsers';
import { Template } from '../../../types/UserInfoTypes';
import { useSelector } from 'react-redux';
import { selectRoleGroups } from '../../../reducers/roleGroupsReducer';
import { useState } from 'react';

const OrgInfoTab = ({
  accountName,
  userRoleGroupId,
}: {
  accountName?: string;
  userRoleGroupId?: string;
}) => {
  const { isAdmin } = useSweepRoleGroups();
  const [canInvite] = usePermissions().evaluatePermissions([
    { permission: ['create:users:invite'] },
  ]);
  const { setRoleManager } = useRoleManagerContext();
  const [isInviteDialogOpen, setIsInviteDialogOpen] = useState(false);
  const roles = useSelector(selectRoleGroups);
  const { sendNewInvitation, afterSendActions } = useInviteUsers({
    template: Template.Account,
  });

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      data-testid="org-info"
      sx={{ zIndex: 1 }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          margin: '0 0 16px 0',
          height: '32px',
        }}
      >
        <Typography ellipsis variant="h3">
          {accountName ? accountName : 'Users'}
        </Typography>
        <Stack direction="row" gap={1}>
          {isAdmin(userRoleGroupId ?? '') && (
            <Stack direction="row" gap={1}>
              <Button variant="system" onClick={() => setRoleManager(true)} size="small">
                Manage roles
              </Button>
            </Stack>
          )}
          {canInvite && (
            <Button onClick={() => setIsInviteDialogOpen(true)} size="small">
              Invite users
            </Button>
          )}
        </Stack>
      </Box>

      <InviteUsersInputWithList hideInviteInput />

      <InviteUsersDialog
        isOpen={isInviteDialogOpen}
        onClose={() => setIsInviteDialogOpen(false)}
        roles={roles ?? []}
        onSendInvitationEmail={sendNewInvitation}
        afterSendActions={afterSendActions}
      />
    </Box>
  );
};

export { OrgInfoTab };
